import { ErrorBoundary } from "@/react/components/shared/ErrorPages/ErrorBoundary";
import {
  canAccessSpaceMembersPage,
  canShowPinnedPostSidebar,
} from "@/react/helpers/spaceHelpers";
import {
  useCurrentSpaceContext,
  usePunditUserContext,
} from "@circle-react/contexts";
import { SkeletonLoader } from "@circle-react-uikit/SkeletonLoader";
import { PinnedPostsV2 } from "./PinnedPostsV2";
import { TopMembersV2 } from "./TopMembersV2";

export const RightSidebarContent = () => {
  const { data: space, isLoading: isSpaceLoading } = useCurrentSpaceContext();
  const { currentCommunityMember, isLoading: isPunditUserLoading } =
    usePunditUserContext();

  if (isSpaceLoading || isPunditUserLoading) {
    return null;
  }

  return (
    <div className="space-y-6">
      {canAccessSpaceMembersPage(space, currentCommunityMember) && (
        <ErrorBoundary
          renderFunc={() => (
            <SkeletonLoader variant="right-sidebar" count={6} />
          )}
        >
          <TopMembersV2 />
        </ErrorBoundary>
      )}
      {canShowPinnedPostSidebar(space, currentCommunityMember) && (
        <ErrorBoundary renderFunc={() => null}>
          <PinnedPostsV2 />
        </ErrorBoundary>
      )}
    </div>
  );
};

RightSidebarContent.propTypes = {};
